import PropTypes from 'prop-types';
import {
  CommonIDPropType,
  BookingRoomSummaryPropType,
  CurrencyPropType,
  BookingGuestPropType,
  BookingCancellationStatusPropType,
  BookingPermissionsPropType
} from './common';

import PaymentCodePropType from './PaymentCode';
import CardSourcePropType from './CardSource';
import PropertyPropType from './Property';
import PaymentMethod from '../enums/PaymentMethod';
import BookingStatus from '../enums/BookingStatus';
import RejectionReason from '../enums/RejectionReason';

const BookingPropType = PropTypes.shape({
  id: CommonIDPropType,
  bookingNumber: PropTypes.string,
  property: PropertyPropType,
  summaryByRoomType: PropTypes.arrayOf(BookingRoomSummaryPropType),
  estimatedSubtotal: CurrencyPropType,
  estimatedTaxesFees: CurrencyPropType,
  estimatedTotal: CurrencyPropType,
  actualSubtotal: CurrencyPropType,
  actualTaxesFees: CurrencyPropType,
  actualTotal: CurrencyPropType,
  checkin: PropTypes.string,
  checkout: PropTypes.string,
  guests: PropTypes.arrayOf(BookingGuestPropType),
  specialRequests: PropTypes.string,
  confirmationNumber: PropTypes.string,
  paymentMethod: PropTypes.oneOf(Object.values(PaymentMethod)),
  bookingStatus: PropTypes.oneOf(Object.values(BookingStatus)),
  confirmationMessage: PropTypes.string,
  cancellationStatus: BookingCancellationStatusPropType,
  cancellationMessage: PropTypes.string,
  cancellationDate: PropTypes.string,
  rejectionReason: PropTypes.oneOf(Object.values(RejectionReason)),
  paymentCode: PaymentCodePropType,
  cardSource: CardSourcePropType,
  supervisor: PropTypes.bool,
  guestCount: PropTypes.number,
  roomCount: PropTypes.number,
  permissions: PropTypes.arrayOf(BookingPermissionsPropType)
});

export default BookingPropType;
